import script from "./eventDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./eventDetail.vue?vue&type=script&setup=true&lang=js"

import "./eventDetail.vue?vue&type=style&index=0&id=8db43e68&lang=less&scoped=true"

import exportComponent from "D:\\code\\saicDesign_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8db43e68"]])

export default __exports__